import { Link } from 'react-router-dom';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { FinancePageLayout } from '@/components/finance';
import { FileSpreadsheet, Users, ArrowRightLeft, ClipboardCheck, CalendarDays, Grid3X3 } from 'lucide-react';

const REPORTS = [
  {
    title: 'DRE - Demonstrativo de Resultado',
    description: 'Receitas, despesas e resultado por período',
    href: '/finance/reports/dre',
    icon: FileSpreadsheet,
  },
  {
    title: 'Recebíveis por Período',
    description: 'Análise semanal e mensal de contas a receber com gráficos',
    href: '/finance/reports/weekly-receivables',
    icon: CalendarDays,
  },
  {
    title: 'Análise de Cohort',
    description: 'Quanto foi recebido por mês dos contratos de cada mês',
    href: '/finance/reports/cohort-analysis',
    icon: Grid3X3,
  },
  {
    title: 'Performance por Vendedor',
    description: 'Métricas de vendas, recebimento e inadimplência',
    href: '/finance/reports/seller-performance',
    icon: Users,
  },
  {
    title: 'Conversões BlueViza → Divus',
    description: 'Clientes que migraram da BlueViza para Divus',
    href: '/finance/reports/blueviza-conversions',
    icon: ArrowRightLeft,
  },
  {
    title: 'Auditoria de Pagamentos',
    description: 'Controle de quem confirmou cada pagamento',
    href: '/finance/reports/payment-audit',
    icon: ClipboardCheck,
  },
];

export default function FinanceReportsMenu() {
  return (
    <FinancePageLayout>
      <h1 className="text-2xl font-bold tracking-tight">Relatórios Financeiros</h1>

      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
        {REPORTS.map((report) => {
          const Icon = report.icon;
          return (
            <Link key={report.href} to={report.href}>
              <Card className="h-full transition-colors hover:bg-muted/50 cursor-pointer">
                <CardHeader>
                  <div className="flex items-center gap-3">
                    <div className="rounded-lg bg-primary/10 p-2">
                      <Icon className="h-5 w-5 text-primary" />
                    </div>
                    <CardTitle className="text-lg">{report.title}</CardTitle>
                  </div>
                </CardHeader>
                <CardContent>
                  <CardDescription>{report.description}</CardDescription>
                </CardContent>
              </Card>
            </Link>
          );
        })}
      </div>
    </FinancePageLayout>
  );
}
